module.exports = __webpack_public_path__ + "media/images/logos/WindEurope-a605a8398386edd43ecbc5a9829125f1.svg";